import en_US from './locales/en_US'
import ja_JP from './locales/ja_JP'
import ko_KR from './locales/ko_KR'
import ms_MY from './locales/ms_MY'
import th_TH from './locales/th_TH'
import zh_CN from './locales/zh_CN'
import zh_TW from './locales/zh_TW'

const messages = {
  en: en_US,
  zh: zh_CN,
  ko: ko_KR,
  ja: ja_JP,
  tw: zh_TW,
  ms: ms_MY,
  th: th_TH,
}

export default messages
